<template>
    <div class="agency-program">
        <div>
            <div class="logo">
                <img src="/images/AgencyProgramLogo.png">
            </div>
            <div class="title">
                PPC Shield for Agencies
            </div>
            <div class="subtitle">
                If you're part of an agency or manage multiple Google Ads accounts for clients, you can apply for a PPC Shield account for agencies and enjoy this new interface, designed specifically for you.
            </div>
            <div class="text" style="font-weight: 500;">
                What should you do?
            </div>
            <div class="numeric-list">
                <div><span class="numeric-list-number">1.</span>Apply for Agency account</div>
                <div><span class="numeric-list-number">2.</span>Encourage your clients to protect their Google Ads accounts with PPC Shield</div>
                <div><span class="numeric-list-number">3.</span>Help them to subscribe to PPC Shield and set up their account</div>
            </div>
            <div class="text" style="font-weight: 500;">
                What will you get?
            </div>

            <div class="numeric-list">
                <div><span class="numeric-list-number">1.</span>Convenient way to manage all clients' accounts from one dashboard</div>
                <div><span class="numeric-list-number">2.</span>Login to any client's account via single sign-on (SSO)</div>
                <div><span class="numeric-list-number">3.</span>Easily link and unlink client accounts</div>
            </div>

            <button class="btn btn-primary mb-2" :disabled="!!apply_date" v-on:click="applyAgencyProgram">APPLY FOR FREE</button>

            <div v-if="apply_date" style="font-weight: 500;">
                Application received on: {{apply_date}} UTC. Further details will be sent to your email address {{email}} within 48 hours.
            </div>

            <div v-if="error" style="color: red;">
                {{error}}
            </div>
        </div>

        <modal :height="'auto'" :width="'400px'" name="apply-modal">
            <div class="informative-modal flex flex-col">
                <div class="header">
                    Agency program application
                </div>

                <div class="body">
                    Application received on: {{apply_date}} UTC. Further details will be sent to your email address {{email}} within 48 hours.
                </div>

                <div class="footer flex justify-end space-x-2">
                    <button class="btn btn-gray" @click="$modal.hide('apply-modal')">CLOSE</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        name: 'agencyprogram',
        props: ['agency_program_application_date', 'email'],
        data: function () {
            return {
                apply_date: this.agency_program_application_date,
                error: '',
            }
        },
        methods: {
            applyAgencyProgram(){
                axios.post('/agencyprogram/apply')
                    .then(info => {
                        if(info.data.error){
                            this.error = info.data.error;
                            this.apply_date = null;
                        }
                        else{
                            this.apply_date = info.data.date;
                            this.$modal.show('apply-modal');
                        }
                    })
                    .catch(err => console.log('err', err));
            }
        },
        mounted() {

        }
    }
</script>
